import { useState, useEffect } from "react";
import { axiosApi } from '../../api/setupApi';

const FALLBACK_ENDPOINTS = [
  (role) => `/convergence?role=${encodeURIComponent(role)}`,
  () => '/convergence/byType',
  () => '/convergence/list',
  () => '/convergence/getAlltype'
];

function normalizeResponse(resp) {
  if (!resp) return [];
  if (Array.isArray(resp)) return resp;

  if (Array.isArray(resp.data)) {
    return resp.data;
  }

  if (resp.success && Array.isArray(resp.data)) {
    return resp.data;
  }

  if (resp.success && resp.data && typeof resp.data === 'object') {
    const flattened = [];
    Object.entries(resp.data).forEach(([group, value]) => {
      if (Array.isArray(value)) {
        flattened.push(...value.map((item) => ({ ...item, type: item.type ?? group })));
      }
    });
    if (flattened.length) {
      return flattened;
    }
  }

  if (resp.rows && Array.isArray(resp.rows)) {
    return resp.rows;
  }

  return [];
}

export default function useConvergence() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;

    async function load() {
      const role = localStorage.getItem("role") || "admin";
      const tried = [];
      let lastError = null;

      for (const endpointFactory of FALLBACK_ENDPOINTS) {
        const endpoint = endpointFactory(role);
        tried.push(endpoint);
        try {
          const { data: resp } = await axiosApi.get(endpoint);
          const normalized = normalizeResponse(resp);
          if (isMounted) {
            setData(normalized);
            setError(null);
            setLoading(false);
          }
          return;
        } catch (err) {
          lastError = err;
          const status = err?.response?.status;
          const recoverable = !status || [400, 404, 405].includes(status);
          if (!recoverable) {
            break;
          }
        }
      }

      if (isMounted) {
        setData([]);
        setError(
          lastError ||
          new Error(`All convergence endpoints failed (${tried.join(', ')}). Check backend routes.`)
        );
        setLoading(false);
      }
    }

    load();

    return () => {
      isMounted = false;
    };
  }, []);

  return { data, loading, error };
}